var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FF0000","d":"M61.66,116.33L12.82,62.28C1.6,49.86,2.57,30.71,14.99,19.49C27.4,8.27,46.56,9.24,57.78,21.66l5.91,6.54\n\tl7.49-7.56c11.78-11.89,30.96-11.97,42.85-0.19c11.88,11.78,11.97,30.96,0.19,42.85L61.66,116.33z"}));
}

Heart.defaultProps = {"version":"1.1","baseProfile":"tiny","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 128 128","xmlSpace":"preserve"};

module.exports = Heart;

Heart.default = Heart;
